/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/363-subscript': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12 14.219V15h2v1h-3v-2.281l2-.938V12h-2v-1h3v2.281zM10.563 4H8.438L5.5 6.938 2.562 4H.437l4 4-4 4h2.125L5.5 9.062 8.438 12h2.125l-4-4z"/>'
  }
})
